import React, {useEffect, useState} from "react";
import InputForm from "../../../components/ComponentesFormularios/InputForm";
import CheckBox from "../../../components/ComponentesFormularios/CheckBox";
import {convertToString, getItemsState, validArray} from "../../../util/functions";
import {isEmpty} from "../../../util/is";
import {useFormContext} from "react-hook-form";
import {Colors} from "../../../assets/colors/Colors";
import Tooltip from "@mui/material/Tooltip";
import {modalSideService} from "../../../services/modalSideService";
import Emitter from "../../../EventEmitter/EventEmitter";
import {ConstantEventEmitter} from "../../../data/ConstantEventEmitter";


const ViewListaSubPortafoliosByPortafolio = ({properties}) => {

  const { register, handleSubmit, formState: { errors }, control, setValue, getValues } = useFormContext();
  const { jsSubPortafoliosComerciales, portafolioId, params } = properties;
  const [stateFilter, setStateFilter] = useState("");
  const [stateCheckbox, setStateCheckbox] = useState([]);
  const [data, setData] = useState(validArray(getValues("portafolioMaterial")));


  const handleChangeCheckBox = ({name, checked, idSubportafolio, portafolioId}) => {

    if(checked){
      setStateCheckbox([...stateCheckbox, convertToString(idSubportafolio)]);
    }
    else{
      setStateCheckbox(stateCheckbox.filter(x => convertToString(x) !== convertToString(idSubportafolio)));
    }

  }

  const handleChangeInput = value => {

    let arrData = validArray(getValues("portafolioMaterial")).slice();
    setStateFilter(value);
    setData(arrData?.filter(x =>
      convertToString(x.id)?.toUpperCase()?.includes(convertToString(value)?.toUpperCase()) ||
      convertToString(x.text)?.toUpperCase()?.includes(convertToString(value)?.toUpperCase())));

  }

/*
  const handleSave = () => {

    let countUnChecked = 0;

    params.api.forEachNode(node => {

      let data = node.data;
      let jsSubPortafolios = validArray(data.jsSubportafolios).slice();
      for(let item of jsSubPortafolios){

        if(stateCheckbox.indexOf(convertToString(item.idSubportafolio)) !== -1){

          item.checked = true;

        }

        if(!item.checked){
          countUnChecked++;
        }

      }

      const countSubPortafolios = validArray(data.jsSubportafolios).length;
      data.jsSubportafolios = jsSubPortafolios.slice();
      data.totalPortafolioMateriales = countSubPortafolios === 0
        ? '0/0'
        : `${Number(countSubPortafolios) - countUnChecked}/${countSubPortafolios}`;


    })


    Emitter.emit(ConstantEventEmitter.handleClickViewSubportafoliosSave);

    modalSideService.clear();

  }
*/

  useEffect(() => {

    let arrInitChecked = [];
    for(let item of jsSubPortafoliosComerciales){

      if(item.checked){
        arrInitChecked.push(item.idSubportafolio);
      }

    }

    setStateCheckbox(arrInitChecked);

  },[])

  return(
    <div className="p-2">

      <div className="mb-3 d-flex align-items-center justify-content-end">
        {/*<Tooltip title="Guardar" aria-label="guardar">
          <a onClick={() => handleSave()} className="icon-container-actions d-flex">
            <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
            <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save fa-2x"/>
          </a>
        </Tooltip>*/}

        <Tooltip title="Cerrar" aria-label="cerrar">
          <a onClick={() => modalSideService.clear()} className="icon-container-actions d-flex mr-0">
            <div style={{backgroundColor: Colors.RED_SWITCH_INACTIVE}}/>
            <i style={{color: Colors.RED_SWITCH_INACTIVE}} className="fas fa-times fa-2x"/>
          </a>
        </Tooltip>
      </div>

      <p className="mb-0 text-justify">Aqui podrás visualizar y buscar los subportafolios asociados al portafolio seleccionado</p>

      <InputForm identificador={`filterSubPortafolios`} label={``} value={stateFilter}
                 placeholder="Buscar..." type="text" className={`px-0 col-12`} handleChange={({name, value}) => handleChangeInput(value)}
      />

      <hr className="mt-2 mb-3"/>

      <p className="font-weight-bold">Lista de subportafolios</p>

      <div className="px-0 col-12">

        {
          data?.map((item) => (
            <div className="my-1" key={`key${item.id}`} >
              <CheckBox disabled={true}
                        identificador={`check${item.id}`}
                        value={stateCheckbox?.indexOf(convertToString(item.id)) !== -1}
                        label={`${item.id} - ${item.text}`}
                        styleCheck={{marginLeft: 0}} styleLabel={{marginLeft: "1.25rem"}}
                        onChange={({name, checked}) => handleChangeCheckBox({name, checked, idSubportafolio: item.id, portafolioId})}/>
            </div>
          ))
        }

      </div>

    </div>
  )

}

export default ViewListaSubPortafoliosByPortafolio;
